module.exports = __webpack_public_path__ + "static/img/goods-5.8c32169.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/visa-api/goods-5.png
// module id = 4H5r
// module chunks = 4